import React from 'react';
import { useRecoilValue } from 'recoil';
import { lookupState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import AddToRma from 'pages/NewCaseSearch/subcomponents/AddToRma';
import IncorrectPartNumber from 'pages/NewCaseSearch/subcomponents/IncorrectPartNumber';
import RmaFiels from 'pages/NewCaseSearch/subcomponents/RmaFields';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import RequestReview from 'pages/NewCaseSearch/subcomponents/RequestReview';
import { Flex } from 'components/layout/Flex';

const PartNotEligible = () => {
  const { lookupResults, selectedResult, reviewRequested } = useRecoilValue(lookupState);
  const { serialNumber, product } = selectedResult;
  const headerCard = [{ title: 'Serial #:', value: serialNumber }];
  const partNotEligibleMessage = 'This serial number is out of warranty and not eligible for RMA';

  return (
    <Flex direction="column">
      {lookupResults.length > 1 ? null : <Header cards={headerCard} />}

      <Flex spacing="space-between">
        <Flex direction="column" spacing="space-between" grow="1">
          <Product statusMessage={partNotEligibleMessage} {...product} />
          {reviewRequested ? <RmaFiels /> : null}
        </Flex>
        <WarrantyActions>
          <AddToRma disabled={!reviewRequested} />
          {lookupResults.length > 1 || reviewRequested ? null : (
            <>
              <IncorrectPartNumber />
            </>
          )}
          <RequestReview />
        </WarrantyActions>
      </Flex>
    </Flex>
  );
};

export default PartNotEligible;
